import { Controller } from "@hotwired/stimulus";
import consumer from '../channels/consumer';

export default class extends Controller {
  static targets = ['progressBar']

  connect() {
    this.initChannel(this.context.element.dataset.id, this.context.element.dataset.importCompleteUrl);
  }

  initChannel(id, importCompleteUrl) {
    const that = this;

    var finished = false
    consumer.subscriptions.create({ channel: "GenericFileImportChannel", id: id }, {
      received(data) {
        if (!finished) {
          console.log(data)
          that.progressBarTarget.style.width = `${data.percentage}%`;

          if(data.percentage === 100) {
            finished = true;
            setTimeout(() => {
              Turbo.visit(importCompleteUrl, { action: 'replace' });
            }, 300);
          }
        }
      }
    })
  }
}
